var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "DC4DDD59-60EB-463E-BD00-1C02B8C45F6F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 16 0 16 16 0 16"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "VHR-UI-Oct-21---Built-by-US",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Owners_NA_Vehicle-Healthview_1.1",
    transform: "translate(-387.000000, -3077.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#F4F4F4",
    x: 0,
    y: 0,
    width: 1440,
    height: 5301
  }), /*#__PURE__*/React.createElement("g", {
    id: "Widget-/-Ford-Dealer-/-Web-Copy",
    transform: "translate(-1.000000, 2861.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "white-bg",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 1441,
    height: 335
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(361.999483, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lines",
    transform: "translate(25.497861, 171.037888)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(26.000517, 200.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.57168158,1.06291346 L5.33377082,4.66354956 L3.93184015,6.06445396 C3.93184015,6.06445396 4.87685323,8.13839455 6.36909232,9.6317608 C7.8613314,11.1240519 9.9556266,12.0551211 9.9556266,12.0551211 L11.3564822,10.6542167 L14.9322655,12.4249685 C14.9322655,12.4249685 14.5742571,13.365714 13.8313628,14.1086341 C12.7100333,15.2300027 12.2488153,15.0052989 11.6102058,14.6956593 C9.51161022,13.6732033 7.38613711,12.140057 5.62189767,10.3779063 C3.85980844,8.61468055 2.32671554,6.48805821 1.30537035,4.38938945 C0.99466639,3.75075767 0.769970447,3.2895236 1.89237506,2.168155 C2.6395697,1.41985917 3.57168158,1.06291346 3.57168158,1.06291346 M4.87685323,11.1240519 C6.74215209,12.9894158 8.98158581,14.5902958 11.1489878,15.6439307 C12.1950603,16.153546 13.1432987,16.2900885 14.5774824,14.8547797 C15.324677,14.1086341 15.6988119,13.2743273 15.8966303,12.8679252 C16.0922986,12.4625983 16.0460693,11.8003135 15.442938,11.5003501 C14.8398068,11.2003867 12.5724205,10.0822435 11.9725146,9.78120493 C11.4263637,9.50811996 10.9941734,9.52317189 10.496402,10.0220358 C10.0480852,10.4725185 9.74705716,10.7714067 9.74705716,10.7714067 C8.87730109,10.335976 7.8613314,9.6317608 7.11521186,8.88454011 C6.36909232,8.13839455 5.65200048,7.1438922 5.2155098,6.27303067 C5.2155098,6.27303067 5.45418204,6.02574901 5.96485464,5.52365971 C6.47552724,5.02264555 6.50885534,4.65709874 6.20567708,4.04749567 C5.90142373,3.4378926 4.80052112,1.15967585 4.49949306,0.556523613 C4.1995401,-0.0455534891 3.53727838,-0.0928595472 3.1319656,0.103890649 C2.72557772,0.300640845 1.89129996,0.675863896 1.14518042,1.42200945 C-0.290078355,2.85624312 -0.153540629,3.80558969 0.356056868,4.85169866 C1.40965507,7.01810109 3.01155438,9.25868802 4.87685323,11.1240519",
    id: "Fill-1",
    fill: "#00095B",
    mask: "url(#mask-2)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.8c628928a514769e9345d9d7db1a0c83.svg";
export { ForwardRef as ReactComponent };